import config from '../../infra/config';

const HOST = config.PROXY_TOWER_API;
const HEADERS = { 'wait-for-completion': 'false' };

export default {
  getSegmentIds: (audience) => ({
    url: `${HOST}/api/1/get-segment-ids`,
    headers: { ...HEADERS },
    payload: { ...audience },
  }),
  getRawDemographicsDataByLogicalStatement: (payload, params) => ({
    method: 'post',
    params,
    payload,
    headers: { ...HEADERS },
    url: `${HOST}/api/v2/audience/demographics`,
  }),
  getRawInterestsDataV1: (payload) => ({
    method: 'post',
    payload,
    headers: { ...HEADERS },
    url: `${HOST}/api/1/ui-related-keywords2`,
  }),
  getRawInterestsDataV2: (payload, searchType, uriSuffix) => ({
    method: 'post',
    payload,
    headers: { ...HEADERS },
    url: `${HOST}/api/v2/audience/interests/${searchType}${uriSuffix}`,
  }),
};
